import Vue from 'vue'
import BaseIcon from '@/components/base-icon/base-icon.vue'
import RefreshBtn from '@/components/ui/refresh-btn/refresh-btn.vue'
import RemoteInlineSvg from '@/components/ui/remote-inline-svg/remote-inline-svg.vue'
import Checkbox from '@/components/ui/checkbox/checkbox.vue'
import Dropdown from '@/components/ui/dropdown/dropdown.vue'
import AvatarImage from '@/components/ui/avatar-image/avatar-image.vue'

Vue.component('base-icon', BaseIcon)
Vue.component('refresh-btn', RefreshBtn)
Vue.component('remote-inline-svg', RemoteInlineSvg)
Vue.component('checkbox', Checkbox)
Vue.component('dropdown', Dropdown)
Vue.component('avatar-image', AvatarImage)
